import {
    boxesSPANISH,
    situationsSPANISH,
    slidesSPANISH,
    buyHeadersSPANISH,
    authorsSPANISH,
} from "../../esp_resources";

const translationSpanish = {
    esp: {
        translation: {
            siteIsNotBeingUsedInfo:
                "¡Este sitio ya no está disponible o activo. Sirve solo para fines de presentación!",
            navigation: {
                examples: {
                    name: "Ejemplos de uso",
                    link: "ejemplos",
                },
                about: {
                    name: "Planificador",
                    link: "planificador",
                },
                contact: {
                    name: "Contacto",
                    link: "contacto",
                },
                newsletter: {
                    name: "Newsletter",
                    link: "newsletter",
                },
                changeLanguage: {
                    name: "Cambiar idioma",
                },
            },

            externalLinks: {
                shop: "https://get-creative-everyday-demo.netlify.app/",
            },

            boxes: boxesSPANISH,

            quotes: {
                possible: "¿Es esto posible?",
                organiser:
                    "¿Organizador, inspirador y ahorrador de tiempo, todo en uno?",
                teachers: "¿Dirigido especialmente a los profesores de inglés?",
                tool: "Already fully in English?",
            },

            situations: situationsSPANISH,

            slides: slidesSPANISH,

            buyHeaders: buyHeadersSPANISH,

            authorsDescriptions: authorsSPANISH,

            atoms: {
                header: `<b>Agenda y planificador</b> con ideas listas para usar
                en las clases de ingléspara
                <br />
                <b>los niños más pequeños</b>`,

                buyNow: "Compra ahora",

                signUp: "Inscribirse",

                hereYouAre: "¡Aquí está!",

                creativityBoost:
                    "Proporcionamos creatividad a los profesores todos los días",

                isPlannerGoodForYou:
                    "¿Estás seguro de que Get Creative Every Day es para ti?",

                checkItOut: "¡Compruébalo!",

                meetExpectations:
                    "¿Sigues buscando el planificador perfecto que cumpla todas tus expectativas?",

                youFoundIt: "¡Aquí lo tienes!",

                fromTeachersToTeachers: "De Profesores para Profesores",

                authorsCircle: {
                    content: `Para colaborar en el contenido, invitamos a profesores de inglés que
                        ofrecieron ideas, consejos y trucos basados en su práctica diaria.
                        Parte del material también <b>procede de los recursos</b>`,
                    span: "de la revista Get Creative",
                },

                authorsContribution: "Algunos de los autores contribuyentes:",

                notEnoughInfo: "¿Aún no tienes suficiente información?",
                signUpForNewsletter:
                    "¡Suscríbete a nuestro boletín para obtener más!",

                yourEmail: "Tu correo electrónico",

                messages: {
                    emailSaved: "¡El correo electrónico se ha guardado!",
                    emailNotSaved:
                        "El correo electrónico no se ha guardado. Por favor, inténtelo de nuevo más tarde.",
                    emailExist: "¡El correo electrónico ya ha sido registrado!",
                },

                from: "de",

                polish: "polski",
                english: "english",
                spanish: "española",
            },
        },
    },
};

export default translationSpanish;
